import { render, staticRenderFns } from "./platformSelection.vue?vue&type=template&id=10e58801&scoped=true"
import script from "./platformSelection.vue?vue&type=script&lang=js"
export * from "./platformSelection.vue?vue&type=script&lang=js"
import style0 from "./platformSelection.vue?vue&type=style&index=0&id=10e58801&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e58801",
  null
  
)

export default component.exports